import { reducers } from './reducers';
export const injectProfileReducers = store => {
  store.injectReducer(reducers);
};